import { plugin, debug } from 'light-component';
import { Select } from 'antd';
import { Icons } from 'zf-web-components/icons';
import { t } from '../../i18n';
import { Require } from '../component';
import styles from './style.module.less';
import type { SelectProps } from './types';
import type { ReactElement } from 'react';

export function WidgetSelects(props: SelectProps): ReactElement {
  debug.widget('dashboard select', props);

  const { allowClear = true, isTranslate = true } = props;

  if (props.mode === 'thumbnail') {
    return (<ThumbnailSelect />);
  }

  let options = props.options?.map?.(item => ({
    value: item.value,
    label: isTranslate ? t(item.title) : item.title
  }));
  const uniqueValue = new Set(options?.map(item => item.value));
  options = options?.filter(item => uniqueValue.delete(item.value));

  return (
    <div className={props.className ?? styles.propertyItem}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title)}</span>
      </div>
      <Select
        className={styles.selectBox}
        disabled={props.readonly}
        title={t(props.title)}
        placeholder={t(props.placeholder ?? '')}
        onChange={value => props.onChange?.(value)}
        value={props.value}
        options={options}
        filterOption={(input, options) => (options?.label ?? '').toLowerCase().includes(input.trim().toLowerCase())}
        showSearch
        allowClear={allowClear}
        popupMatchSelectWidth={props.popupMatchSelectWidth ?? true}
      />
    </div>
  );
}

function ThumbnailSelect(): ReactElement {
  return (
    <div className={styles.control}>
      <Icons name='AppstoreAddOutlined' className={styles.icon} />
    </div>
  );
}
plugin.register({ kind: 'widget', type: 'select', component: WidgetSelects });
